import { snakeToCamel } from "../";

export const removeKeys = <T extends object, K extends keyof T>(
  obj: T,
  keysToRemove: K[]
): Omit<T, K> => {
  const result = { ...obj };
  for (const key of keysToRemove) {
    delete result[key];
  }
  return result;
};

export const getLastKeyValue = (key: string): string => {
  const lastPart = key.includes(".") ? key.split(".").pop()! : key;
  return snakeToCamel(lastPart);
};
